import cookieOptions from './cookie.options'

let cookies = {
  modal: false,
  consent: false,
  scripts: [],
  enabled: [],
  enabledList: [],
  css: true,
  controlButton: true,
  barPosition: 'bottom-full',
  necessary: [],
  functional: [],
  optional: [],
}

Object.assign(cookies, cookieOptions);
cookies.colors = {
  barTextColor: '#fff',
  
  barBackground: '#24318a',
  barButtonColor: '#24318a',
  barButtonBackground: '#fff',
  barButtonHoverColor: '#fff',
  barButtonHoverBackground: '#24318a',
  
  modalOverlay: '#000',
  modalTextColor: '#000',
  modalBackground: '#fff',
  modalOverlayOpacity: 0.8,
  modalButtonBackground: '#fff',
  modalButtonColor: '#24318a',
  modalButtonHoverColor: '#fff',
  modalButtonHoverBackground: '#24318a',
  modalUnsavedColor: '#fff',

  checkboxActiveBackground: '#80cc28',
  checkboxInactiveBackground: '#f65314',
  checkboxActiveCircleBackground: '#fff',
  checkboxInactiveCircleBackground: '#fff',
  checkboxDisabledCircleBackground: '#fff',
  checkboxDisabledBackground: '#ffbb004d',
  
  controlButtonIconColor: '#fff',
  controlButtonBackground: '#24318a',
  controlButtonIconHoverColor: '#24318a',
  controlButtonHoverBackground: '#fff',
};
Object.assign(cookies.colors, {}); // @warn override cookie.colors here

let methods = {
  get: (cookie) => {
    if (process.browser) {
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      let name = `${cookie}=`;
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
    }
    return '';
  },

  set: ({ name, value = '', expires = '', path = '/', domain }) => {
    let domainName = domain ? domain : cookies.domain ? `.${cookies.domain}` : domain;
    document.cookie = `${name}=${value};expires=${expires};path=${path}${domainName !== undefined ? `;domain=${domainName}` : ';'}`;
  },

  slugify: (str) => {
    str = str.replace(/^\s+|\s+$/g, '');
    str = str.toLowerCase();
    let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    let to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (let i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

    return str;
  },

  remove: (name) => {
    if (process.browser) {
      let domain = window.location.hostname;
      cookies.set({ name, expires: 'Thu, 01 Jan 1970 00:00:00 GMT', domain });
      for (let j = domain.split('.'); j.length;) {
        let o = j.join('.');
        cookies.set({ name, expires: 'Thu, 01 Jan 1970 00:00:00 GMT', domain: `.${o}` });
        j.shift();
      }
    }
  }
}

Object.assign(cookies, methods);

const clearCookies = () => {
  let disabled = cookies.optional.filter(c => {
    let cookieName = typeof (c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
    return !cookies.enabledList.includes(cookies.slugify(cookieName))
  });
  if (disabled.length > 0) {
    disabled.forEach(c => {
      if (c.declined) c.declined();
      if (c.cookies && c.cookies.length > 0) {
        c.cookies.forEach(i => {
          cookies.remove(i);
        })
      }
    })
  }
}

const setHead = () => {
  if (cookies.enabled.length > 0) {
    let head = document.getElementsByTagName('head')[0];
    cookies.enabled.forEach(c => {
      if (c.src) {
        let script = document.createElement('script');
        script.src = c.src;
        head.appendChild(script);
        script.addEventListener('load', () => {
          if (c.accepted) c.accepted();
        })
      }
    })
  }
}

const callAcceptedFunctions = () => {
  if (cookies.enabled.length > 0) {
    cookies.enabled.forEach(c => {
      if (c.accepted && !c.src) c.accepted();
    })
  }
}

cookies.consent = cookies.get('cookie_control_consent') === 'true' ? true : false;

if (cookies.consent === true) {
  let enabledFromCookie = cookies.get('cookie_control_enabled_cookies');
  cookies.enabled.push(...cookies.optional.filter(c => {
    let cookieName = typeof (c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
    return enabledFromCookie.includes(cookies.slugify(cookieName))
  }));
  cookies.enabledList = cookies.enabled.length > 0 ? cookies.enabled.map(c => {
    let cookieName = typeof (c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
    return cookies.slugify(cookieName)
  }) : [];
}

if (cookies.necessary) cookies.enabled.push(...cookies.necessary.filter(c => { return c.src || c.accepted }))

document.onreadystatechange = function () {
  if (document.readyState == 'complete') {
    setHead();
    clearCookies();
    callAcceptedFunctions();
  }
}

export default cookies